export default "__VITE_ASSET__9o2ZzTLX__";